"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = exports.MONS_ROUTE_BASE = exports.ShipmentStatus = exports.ShipmentDetailsPageColors = exports.ManageShipmentPageColors = exports.textFontProps = void 0;
exports.textFontProps = {
    family: 'Amazon Ember',
    size: '13dp'
};
exports.ManageShipmentPageColors = {
    borderColor: "#D5D7D9",
    tileContainerColor: "#F2F4F5",
    textColor: "#62676B",
    headingTextColor: "#1C2227",
    infoRowResultsColor: "#5E6A78",
    orangeBadgeColor: "#EF6C00",
    greenBadgeColor: "#43A047"
};
exports.ShipmentDetailsPageColors = {
    pageBackgroundColor: "#F2F4F5"
};
exports.ShipmentStatus = {
    IN_TRANSIT: "In-Transit",
    COMPLETE: "Complete",
    DELAYED: "Delayed"
};
exports.MONS_ROUTE_BASE = "/AffordabilityWebsite";
var BASE = {
    UtilsPath: "https://".concat(exports.MONS_ROUTE_BASE, "/mobile/assets/scripts/Utils.grout.js"),
    Apis: {
        ListApi: "https://".concat(exports.MONS_ROUTE_BASE, "/api/recentlyUpdatedShipments"),
        DetailsPageNavigationApi: "ceramic://".concat(exports.MONS_ROUTE_BASE, "/mobile/pages/shipmentdetails.json5")
    },
    Colors: { ManageShipmentPageColors: exports.ManageShipmentPageColors, ShipmentDetailsPageColors: exports.ShipmentDetailsPageColors },
    ShipmentStatus: exports.ShipmentStatus
};
var LOCAL = __assign(__assign({}, BASE), { UtilsPath: "http://".concat(exports.MONS_ROUTE_BASE, "/mobile/assets/scripts/Utils.grout.js"), Apis: {
        ListApi: "http:///data/data.json",
        DetailsPageNavigationApi: "ceramic:///pages/shipmentdetails.json5"
    } });
var BETA = __assign({}, BASE);
var GAMMA = __assign({}, BETA);
var PROD = __assign({}, GAMMA);
var ConstantObject = {
    LOCAL: LOCAL,
    BETA: BETA,
    GAMMA: GAMMA,
    PROD: PROD
};
var targetEnvironment = process.env.NODE_ENV == "development" ? "LOCAL" : "BETA";
exports.Constants = ConstantObject[targetEnvironment];
